import { type Patient } from './Patient.js';

export interface CameraZonePoint {
  x: number;
  y: number;
}

export const CAMERA_ZONE_TYPES = [
  'bed',
  'chair',
  'couch',
  'wheelchair',
  'toilet',
  'bathroom',
  'kitchen',
  'doorway',
  'floor',
  'other',
] as const;

export type CameraZoneType = (typeof CAMERA_ZONE_TYPES)[number];

export type CameraVisionPreprocessing = 'auto' | 'none' | 'ir_normalize' | 'contrast' | 'denoise';

export interface CameraVisionSettings {
  streamQuality: 'low' | 'high';
  preprocessing: CameraVisionPreprocessing;
  imageSize: 640 | 960 | 1280;
  modelSize: 'n' | 's' | 'm';
  confidence: number;
}

export const DEFAULT_CAMERA_VISION_SETTINGS: CameraVisionSettings = {
  streamQuality: 'low',
  preprocessing: 'auto',
  imageSize: 640,
  modelSize: 's',
  confidence: 0.35,
};

export interface CameraZone {
  id: string;
  label: string;
  type?: CameraZoneType | null;
  corners: CameraZonePoint[];
}

export type CreateCamera = {
  name: string;
  ipAddress: string;
  port: string;
  username: string;
  password: string;
  vod?: string;
  patientId: string;
  areaDescription?: string | null;
  irDualCapture?: boolean;
};

export type Camera = CreateCamera & {
  id: string;
  patient: Patient;
  metadata: any; // Todo
  lastActivity: string;
  lastReachable: Date;
  motionDetection: boolean;
  zones?: CameraZone[] | null;
  visionSettings?: CameraVisionSettings | null;
  // Set when the camera is attached to an NVR (e.g. Reolink). Axis cameras are
  // direct and leave these null.
  nvrId?: string | null;
  channel?: string | null;
  irCutFilter?: boolean | null;
  irIlluminator?: boolean | null;
  irSyncedAt?: string | null;
};
